"use strict";

/** @const APP_INDEX */
const APP_INDEX = 'index.php';

/**
 * @class LocationHandler
 */
class LocationHandler
{
    /**
     * @param location
     */
    redirect (location)
    {
        window.location.href = this.getBaseUrl() + '/' + location;
    }

    /**
     * @returns {string}
     */
    getBaseUrl ()
    {
        let currentLocation = this.constructor._getCurrentLocationUrl();
        return currentLocation.substring(0, currentLocation.indexOf(APP_INDEX) + APP_INDEX.length);
    }

    /**
     * @returns {string}
     */
    getCurrentLocation ()
    {
        return this.constructor._getCurrentLocationUrl();
    }

    /**
     * @returns {string}
     * @private
     */
    static _getCurrentLocationUrl ()
    {
        return window.location.href;
    }
}

/** @export LocationHandler */
export default new LocationHandler();



// WEBPACK FOOTER //
// ./assets/js/shared/utility/location_handler/location_handler.js